<script setup lang="ts">
import { AppShell, usePermissions, useSession } from '@yc/ui-kit'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()
const { menus } = usePermissions()
const { actingTenantId } = useSession()

const active = computed(() => route.path)

function go(target: string): void {
  if (target === route.path) return
  void router.push(target)
}

// 切换货主后所有列表的数据域都变了，整页重载比逐页手动刷新更不容易漏
function onTenantChanged(): void {
  window.location.reload()
}
</script>

<template>
  <AppShell :menus="menus" :active="active" app-name="云仓供应链平台" @navigate="go" @tenant-changed="onTenantChanged">
    <el-text v-if="actingTenantId !== null" type="info" size="small">
      当前业务视角：{{ actingTenantId === 0 ? '全部货主' : `货主 #${actingTenantId}` }}，列表数据已按此视角过滤。
    </el-text>
    <RouterView />
  </AppShell>
</template>
